import type { ReactNode } from 'react';
import './Stat.css';

export interface StatProps {
  /** The number, already formatted for the tenant locale. */
  value: ReactNode;
  label: string;
  tone?: 'neutral' | 'danger' | 'success' | 'warning' | 'muted';
  size?: 'sm' | 'md' | 'lg';
  /** What the number is made of, on hover: its scope, source and whether it is measured or estimated. */
  title?: string;
}

/** A number with its label under it; the biggest thing is the number (interface principles). */
export function Stat({ value, label, tone = 'neutral', size = 'md', title }: StatProps): ReactNode {
  return (
    <div className={`pui-stat pui-stat--${size} pui-stat--${tone}`} title={title}>
      <span className="pui-stat__value">{value}</span>
      <span className="pui-stat__label">{label}</span>
    </div>
  );
}

/** A row of stats that wraps at narrow widths. */
export function StatRow({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={['pui-stat-row', className].filter(Boolean).join(' ')}>{children}</div>;
}
